import { ValidationErrorData } from './common';
import { GdUpdateAdGroupRegionsActionInput } from './graphql-grid';
import { RegionsEditorQuickSelectItem } from './regionsEditor';

export type RegionsTransformEditorsState = Record<string, RegionsTransformEditorState>;

export interface RegionsTransformEditorState {
    isOpened: boolean;
    typeSelectedRegionsTransform: GdUpdateAdGroupRegionsActionInput;
    quickSelectedItems?: RegionsEditorQuickSelectItem[];
    isLoading: boolean;
    isQuickSelectItemsLoading: boolean;
    campaignsIds: string[];
    groupsIds?: string[];
    errors?: ValidationErrorData[];
}

export enum RegionsTransformEditorId {
    groupsGrid = 'groupsGrid',
    campaignsGrid = 'campaignsGrid'
}
